module.exports = __webpack_public_path__ + "img/ep5-7.5db8052a.png";